module.exports = __webpack_public_path__ + "img/29_62.ebad8b58.png";